// neurotrader-admin/src/pages/OrdersPage.js
import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
// Reutilizaremos o CSS da página de clientes
import './ClientsPage.css';

const OrdersPage = () => {
    const [orders, setOrders] = useState([]);
    const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1, totalOrders: 0 });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const { user } = useAuth();

    const fetchOrders = useCallback(async (page = 1, search = '') => {
        if (!user?.token) return;
        setLoading(true);
        try {
            const { data } = await api.get('/api/admin/orders', {
                headers: { Authorization: `Bearer ${user.token}` },
                params: { page, search, limit: 15 }
            });
            console.log(data.orders);
            setOrders(data.orders);
            setPagination({
                currentPage: data.currentPage,
                totalPages: data.totalPages,
                totalOrders: data.totalOrders,
            });
        } catch (error) {
            toast.error("Falha ao carregar a lista de pedidos.");
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        const timer = setTimeout(() => {
            fetchOrders(pagination.currentPage, searchTerm);
        }, 500);
        return () => clearTimeout(timer);
    }, [fetchOrders, pagination.currentPage, searchTerm]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setPagination(prev => ({ ...prev, currentPage: newPage }));
        }
    };

    return (
        <div className="admin-page-container">
            <h1 className="admin-page-title">Pedidos</h1>

            <div className="table-controls">
                <input
                    type="text"
                    placeholder="Buscar por email ou ID da venda..."
                    className="search-input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span>Total de Pedidos: {pagination.totalOrders}</span>
            </div>

            <div className="clients-table-container">
                <table className="clients-table">
                    <thead>
                    <tr>
                        <th>ID da Venda</th>
                        <th>Cliente</th>
                        <th>Email</th>
                        <th>Produto</th>
                        <th>Valor</th>
                        <th>Método</th>
                        <th>Status</th>
                        <th>Data</th>
                    </tr>
                    </thead>
                    <tbody>
                    {loading ? (
                        <tr><td colSpan="8">Carregando...</td></tr>
                    ) : orders.length > 0 ? (
                        orders.map(order => (
                            <tr key={order.id}>
                                <td data-label="Pedido">{order.sale_id}</td>
                                <td data-label="Nome">{order.customer_name}</td>
                                <td data-label="Email">{order.customer_email}</td>
                                <td data-label="Produto">{order.product_name}</td>
                                <td data-label="Valor">R$ {order.total_price.toFixed(2)}</td>
                                <td data-label="Pagamento">{order.payment_method}</td>
                                <td data-label="Status">{order.status}</td>
                                <td data-label="Data Pedido">{new Date(order.order_created_at).toLocaleString('pt-BR')}</td>
                            </tr>
                        ))
                    ) : (
                        <tr><td colSpan="8">Nenhum pedido encontrado.</td></tr>
                    )}
                    </tbody>
                </table>
            </div>

            <div className="pagination-controls">
                <button onClick={() => handlePageChange(pagination.currentPage - 1)} disabled={pagination.currentPage === 1}>
                    Anterior
                </button>
                <span>Página {pagination.currentPage} de {pagination.totalPages}</span>
                <button onClick={() => handlePageChange(pagination.currentPage + 1)} disabled={pagination.currentPage === pagination.totalPages}>
                    Próxima
                </button>
            </div>
        </div>
    );
};

export default OrdersPage;